import {Component, Input} from '@angular/core';

@Component({
    selector: 'app-card',
    templateUrl: './card.component.html',
    styles: [],
    standalone: false
})
export class CardComponent {
  @Input() stretch = true;
}
